module.exports = __webpack_public_path__ + "static/media/construct-outline.64a31411.svg";